import { useCallback } from "react";

import * as DiscountShared from "../../../../_shared";

import type { DiscountMultiFormModel } from "../type";

type ViewModel = DiscountMultiFormModel["ViewModel"];

export const useActions = (viewModel: ViewModel, onSetViewModel: (viewModel: ViewModel) => void) => {
	const {
		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,

		// 追加設定
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
	} = DiscountShared.Model.UseCase.useSharedActions(viewModel, onSetViewModel);

	/**
	 * 適用ディスカウントの追加
	 */
	const onAddMultiDiscounts = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				multiDiscounts: viewModel.multiDiscounts.concat(value),
			});
		},
		[onSetViewModel, viewModel],
	);
	/**
	 * 適用ディスカウントの変更（DnD での変更を想定）
	 */
	const onChangeMultiDiscounts = useCallback(
		(values: Array<string>) => {
			onSetViewModel({
				...viewModel,
				multiDiscounts: values,
			});
		},
		[onSetViewModel, viewModel],
	);
	/**
	 * 適用ディスカウントの削除
	 */
	const onDeleteMultiDiscounts = useCallback(
		(value: string) => {
			onSetViewModel({
				...viewModel,
				multiDiscounts: viewModel.multiDiscounts.filter((v) => v !== value),
			});
		},
		[onSetViewModel, viewModel],
	);

	return {
		//
		// 公開にする
		onPublish,
		// 非公開にする
		onUnpublish,

		// 基本設定
		// ディスカウント名の変更
		onChangeName,
		// ディスカウント説明の変更
		onChangeDescription,
		// ディスカウントコードの変更
		onChangeDiscountCode,

		// 適用ディスカウント
		// 適用ディスカウントの追加
		onAddMultiDiscounts,
		// 適用ディスカウントの変更
		onChangeMultiDiscounts,
		// 適用ディスカウントの削除
		onDeleteMultiDiscounts,

		// 追加設定
		// ディスカウント上限金額を設定しない
		onUnSettingDiscountPriceTotalLimit,
		// ディスカウント上限金額の変更
		onChangeDiscountPriceTotalLimit,
		// ディスカウントをプラン限定にするかの変更
		onChangeSaleTypeForPlan,
		// キャンセル不可のディスカウントにするかの変更
		onChangeIsUncancelable,
		// ディスカウントの利用可能期間を設定するかの変更
		onChangeSaleTypeForTerm,
		// 公開期間を変更
		onChangeSale,
		// 利用可能期間を変更
		onChangeStayable,
		// 利用可能曜日の変更
		onChangeStayableDayOfTheWeek,
	};
};
